import React from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { ptBR } from '@mui/x-date-pickers/locales'
import { ptBR as ptBRDateFns } from 'date-fns/locale'
import { Grid } from '@mui/material'
import YearMonthPicker from '../yearMonthPicker'
import { MultipleSelectUnidade, MultipleSelectUnidadeBasic } from '../multipleSelectCheck'

export default function FilterFields({ selectedDate, onDateChange, hasAnalyticsPro, unidadeList, unidade, onUnidadeChange, inline = false }) {
    // No modo inline (barra de filtro da tela principal) a data ocupa apenas a
    // largura do próprio campo ("auto") e a unidade cresce para preencher o resto,
    // deixando data, unidade e o botão Buscar na mesma linha.
    const dateGrid = inline ? { md: 'auto' } : { md: hasAnalyticsPro ? 4 : 12 }
    const unidadeGrid = inline ? { md: true } : { md: hasAnalyticsPro ? 8 : 12 }

    return (
        <Grid container spacing={2} alignItems="center" direction="row">
            <Grid item xs={12} {...dateGrid}>
                <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={ptBRDateFns}
                    localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                >
                    <YearMonthPicker handleChangeTo={onDateChange} value={selectedDate} fullWidth={!inline} />
                </LocalizationProvider>
            </Grid>
            <Grid item xs={12} {...unidadeGrid}>
                {hasAnalyticsPro ? (
                    <MultipleSelectUnidade
                        fullWidth
                        unidadeList={unidadeList || []}
                        unidade={unidade}
                        handleChangeTo={onUnidadeChange}
                    />
                ) : (
                    <MultipleSelectUnidadeBasic />
                )}
            </Grid>
        </Grid>
    )
}
